export default __webpack_public_path__ + "static/media/musicJunkies.08439fdd.PNG";